import { getSkillIcon } from "@app/lib/skill";
import { UNAVAILABLE_SKILL_LABEL } from "@app/lib/skills/format";
import { AlertCircle, Chip, Tooltip } from "@dust-tt/sparkle";
import { NodeViewWrapper } from "@tiptap/react";
import { useTranslation } from "react-i18next";

interface SkillNodeComponentProps {
  node: {
    attrs: {
      skillId?: string;
      skillIcon?: string | null;
      skillName?: string;
      skillUnavailable?: boolean;
    };
  };
  onDetails?: (skillId: string) => void;
  onRemove?: () => void;
}

export function SkillNodeComponent({
  node,
  onDetails,
  onRemove,
}: SkillNodeComponentProps) {
  const { t } = useTranslation();
  if (node.attrs.skillUnavailable === true) {
    return (
      <NodeViewWrapper className="inline-flex align-middle">
        <Tooltip
          label={t(
            "misc.unavailableSkillTooltip",
            "This referenced skill is unavailable because its visibility or permissions changed."
          )}
          side="top"
          tooltipTriggerAsChild
          trigger={
            <span className="inline-flex">
              <Chip
                label={UNAVAILABLE_SKILL_LABEL}
                icon={AlertCircle}
                color="warning"
                size="xs"
                onRemove={onRemove}
              />
            </span>
          }
        />
      </NodeViewWrapper>
    );
  }

  const skillIcon = node.attrs.skillIcon ?? null;
  const skillName =
    node.attrs.skillName ?? t("conv.skillNodeDefaultName", "Skill");
  const skillId = node.attrs.skillId;
  const handleClick =
    skillId && onDetails ? () => onDetails(skillId) : undefined;

  return (
    <NodeViewWrapper className="inline-flex align-middle">
      <Chip
        label={skillName}
        icon={getSkillIcon(skillIcon)}
        color="primary"
        onClick={handleClick}
        onRemove={onRemove}
        size="xs"
      />
    </NodeViewWrapper>
  );
}
